import React from 'react';
import { connect } from 'react-redux';

const Start = (props) => {
    return <div></div>
}

export default Start;
